import React from 'react'
import { Form, Input, Select } from 'antd'

interface ConditionsToSendProps {
  setIsCustomTime: React.Dispatch<React.SetStateAction<boolean>>
  reference?: 'event' | 'league' | 'organization' | 'class'
}

const ConditionsToSend: React.FC<ConditionsToSendProps> = ({
  setIsCustomTime,
  reference,
}) => {
  const hanldeChange = (value: string) => {
    if (value === 'customTimeToSend') {
      setIsCustomTime(true)
    } else {
      setIsCustomTime(false)
    }
  }
  return (
    <div className="flex gap-16px align-center w-full">
      <div style={{ width: '20%' }}>
        <Form.Item className="form-control" name="timeQuantity">
          <Input
            type="number"
            className="custom-input-field"
            placeholder="0"
            onWheel={e => e.currentTarget.blur()}
          />
        </Form.Item>
      </div>

      <div style={{ width: '25%' }}>
        <Form.Item className="pointer selector-input" name="timePeriod">
          <Select
            className="select-input-field type-select-field"
            placeholder="Select"
            optionLabelProp="label"
            options={[
              {
                value: 'mins',
                label: 'Minutes',
              },
              {
                value: 'days',
                label: 'Days',
              },
              {
                value: 'weeks',
                label: 'Weeks',
              },
            ]}
          />
        </Form.Item>
      </div>

      <div style={{ width: '25%' }}>
        <Form.Item className="pointer selector-input" name="timeFrame">
          <Select
            className="select-input-field type-select-field"
            placeholder="Select"
            optionLabelProp="label"
            options={[
              {
                value: 'before',
                label: 'Before',
              },
              {
                value: 'after',
                label: 'After',
              },
            ]}
          />
        </Form.Item>
      </div>

      <div style={{ width: '30%' }}>
        <Form.Item className="pointer selector-input" name="conditionType">
          {reference === 'event' ? (
            <Select
              className="select-input-field type-select-field"
              placeholder="Select"
              optionLabelProp="label"
              onChange={hanldeChange}
              options={[
                {
                  value: 'event-registration',
                  label: 'Event registration',
                },
                {
                  value: 'event-first-date',
                  label: 'Event First date',
                },
                {
                  value: 'event-last-date',
                  label: 'Event last date',
                },
                {
                  value: 'ticket-first-date',
                  label: 'Ticket Start date',
                },
                {
                  value: 'ticket-last-date',
                  label: 'Ticket last date',
                },
                {
                  value: 'checked-in',
                  label: 'Check-in',
                },
                {
                  value: 'checked-out',
                  label: 'Check-Out',
                },
                {
                  value: 'customTimeToSend',
                  label: 'Custom Time',
                },
              ]}
            />
          ) : (
            <Select
              className="select-input-field type-select-field"
              placeholder="Select"
              optionLabelProp="label"
              onChange={hanldeChange}
              options={[
                {
                  value: 'league-registration',
                  label: 'League registration',
                },
                {
                  value: 'league-first-date',
                  label: 'League First date',
                },
                {
                  value: 'league-last-date',
                  label: 'League last date',
                },
                {
                  value: 'customTimeToSend',
                  label: 'Custom Time',
                },
              ]}
            />
          )}
        </Form.Item>
      </div>
    </div>
  )
}

export default ConditionsToSend
